// Réinitialisation de mot de passe : détection du lien de récupération et
// validation du nouveau mot de passe. Logique isolée du composant pour rester
// testable sans DOM.

export const MIN_PASSWORD_LENGTH = 8;

/**
 * Un lien de récupération Supabase renvoie l'utilisateur sur le Site URL avec
 * un fragment `#access_token=…&type=recovery&…`. Le client Supabase consomme
 * puis efface ce fragment (`detectSessionInUrl`) : il faut donc l'inspecter
 * avant que le client ne soit créé, d'où cette fonction pure.
 */
export function isRecoveryHash(hash) {
  if (typeof hash !== 'string' || !hash) return false;
  return /(^|[#?&])type=recovery(&|$)/.test(hash);
}

/**
 * Règles minimales appliquées côté client. Supabase refuse de son côté les
 * mots de passe trop courts, mais un message en français avant l'aller-retour
 * réseau évite un échec opaque.
 */
export function validateNewPassword(password, confirmation) {
  if (!password || password.length < MIN_PASSWORD_LENGTH) {
    return {
      ok: false,
      error: `Le mot de passe doit faire au moins ${MIN_PASSWORD_LENGTH} caractères.`,
    };
  }
  if (password !== confirmation) {
    return { ok: false, error: 'Les deux mots de passe ne sont pas identiques.' };
  }
  return { ok: true, error: null };
}
